module.exports = __webpack_public_path__ + "img/12.84513f38.jpg";